import {
  FunctionInfo,
  convertFunction,
  convertFunctionName,
} from "@/components/GraphVisualisation/components/AttributeInfo/FunctionInfo";
import { COMMANDS, type Command } from "@imminently/decisively-core/utils";
import sortBy from "lodash/sortBy";
import { MentionCombobox } from "./MentionCombobox";
import { createMentionPluginFactory, getMentionOnSelectItem, renderItem } from "./common";

const FUNCTION_TRIGGER_CHAR = "/";

const functionData = COMMANDS.reduce((functionData, f) => {
  if (!f.hidden) {
    functionData.push({
      data: f,
      text: convertFunctionName(f.id),
      value: convertFunction(f),
      key: f.id
    });
  }
  return functionData;
}, [] as any[]);

export interface FunctionDetailsProps {
  data: Command;
}

export const RenderFunction = (props: FunctionDetailsProps) => {
  const { data } = props;

  if (!data) {
    return "Missing function data";
  }

  return <FunctionInfo command={data} />;
};

export const FunctionCombobox = () => {
  return (
    // @ts-ignore
    <MentionCombobox
      pluginKey={FUNCTION_TRIGGER_CHAR}
      items={sortBy(functionData, "text")}
      onRenderItem={renderItem}
      onRenderDetail={RenderFunction}
      onSelectItem={getMentionOnSelectItem({ key: FUNCTION_TRIGGER_CHAR })}
    />
  );
};

export const createFunctionsPlugin = createMentionPluginFactory({
  key: "functions",
  trigger: FUNCTION_TRIGGER_CHAR,
});
